import { TestType } from "@app/provider/testData/types";
import { capitalizeFirstLetter } from "@app/utils";

//gets all order test types (patient readable) to be passed to modal props
export const getReadableComboOrderTestTypesList = (
  testTypes: TestType[]
): string[] => {
  const orderTypes = testTypes.map((type) => {
    if (type === TestType.SINGLE_GENE_NIPT) {
      return "Fetal Focus";
    }

    return capitalizeFirstLetter(type);
  });
  return orderTypes;
};
